import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DeviceConfigDatastorePathField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (!/^\/$|^\/\/$|^(\/[\w-]+)+$/.test(newValue)) {
      setError('Datastore path must be valid absolute linux path.');
    } else if (newValue === '') {
      setError('Datastore path cannot be blank (use "/")');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Datastore Path'
          id='datastore_path'
          aria-describedby='datastore-path-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='datastore-path-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='datastore-path-helper-text'>
            Enter the subpath to mount within the datastore (use "/" to map to
            the root of the datastore)
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
